import React from "react";
import { Link } from "react-router-dom";
import apiManager from "../../utils/apiManager";
import { imagePrefix } from "../../../public/constants/constants";
import "../../../public/styles/store/store.scss";
import {
  EXPERIENCE_OUR_STORES,
  EXP_OUR_PRODUCTS,
} from "../../constants/app/storeDetailsConstants";
import { espotAPI } from "../../../public/constants/constants";
import appCookie from '../../utils/cookie';
import { InView } from 'react-intersection-observer';
import { isMobile } from "../../utils/utilityManager";

export class StoreDetails extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      espotName: "GI_Homepage_RCBLocateStoreBanner",
      banner1Img: "",
      banner2Img: "",
      icon1: "",
      icon2: "",
      inview: false,
	  source: this.getParameterByName('utm_source'),
      medium: this.getParameterByName('utm_medium'),
      campaign: this.getParameterByName('utm_campaign'),
      utmid: this.getParameterByName('utm_id'),
    };
  }

  getParameterByName(name) {
    name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
    const regex = new RegExp(`[\\?&]${  name  }=([^&#]*)`);
    const results = regex.exec(location.search);
    return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
  }

  getUrl(){
    if(this.state.source == "GMB Optimization")
    {
      appCookie.set('utm_source',this.state.source)
      appCookie.set('utm_medium',this.state.medium)
      appCookie.set('utm_campaign',this.state.campaign)
      appCookie.set('utm_id',this.state.utmid)
    }
  
  }

  getEspotData() {
    apiManager
      .get(espotAPI + this.state.espotName)
      .then(response => {
        const { data } = response || {};
        this.setState({
          banner1Img: data && data.data.banner1Img,
          banner2Img: data && data.data.banner2Img,
          icon1: data && data.data.icon1,
          icon2: data && data.data.icon2,
        });
      })
      .catch(error => {
        this.setState({
          error,
          isLoading: false,
        });
      });
  }

  componentDidMount() {
    this.getEspotData();
    this.getUrl();
  }

  render() {
    // const { storeData, index } = this.state;
    return (
     <InView as="div" onChange={(inView, entry) => this.setState({inview: this.state.inview == true || inView==true? true: false})} style={{minHeight : !isMobile() ? '100px' : '100px'}}>
        { this.state.inview ? 
      <div className="exStore">
        {/* <LazyLoadComponent><img src='https://uatinterio.godrej.com/imagestore/B2C/static/Stores.webp'></img></LazyLoadComponent> */}
        <div
          className="bkg-container" style={{
            backgroundColor: `#F4F4F4`,
          }}>
          <div
            className="content-container"
          
          >
            <div className="content">
              {/* {!isMobile() && <h2 className='subTitle'>{OUR_STORES}</h2>} */}
              <div className="iconImg">
                <img loading="lazy" src={imagePrefix + this.state.icon1} />
              </div>
              <div className="content-details-container">
              <p className="title">{EXPERIENCE_OUR_STORES}</p>
              <div className="details">
                {EXP_OUR_PRODUCTS}{" "}
                <Link to={{ pathname: "/storelocator/kitchens" }}>
                Godrej Interio Store
                </Link>
              </div>

              <div className="details">
              Click below to explore more stores near you
              </div>
              <Link className="storeLink" to="/storelocator/kitchens">
                <button className="btn-flat">LOCATE OUR STORES</button>
              </Link>
              </div>
            </div>
          </div>
          <div className="content-container">
            <div className="content">
              <div className="iconImg">
                <img loading="lazy" src={imagePrefix + this.state.icon2} />
              </div>
              <div className="content-details-container">
              <p className="title">Request A Callback</p>
                <div className="details">
                Have a query regarding a service we offer.
                </div>
                <div className="details">
                  Our representatives will help you with it.
                </div>
              {/* <Link
                            className='storeLink'
                            to={{ pathname: '/storelocator', state: { pincode: getCookie('pincode') } }}
                        >
                            <button className='btn-flat'>{!isMobile() ?'Find More Stores' : 'Explore More Stores' }</button>
                        </Link>
                        <span className='storeLinkSpacer'>OR</span> */}
              <Link className="storeLink" to="/request-callback">
                <button className="btn-flat">REQUEST A CALLBACK</button>
              </Link>
              </div>
            </div>
          </div>
        </div></div> :<></>}
        </InView>
    );
  }
}

export default StoreDetails;
